import { Grid, makeStyles } from "@material-ui/core";
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from "@material-ui/core";
import moment from "moment";
import React from "react";
import useBreakpoint from "../../../hooks/useBreakpoint";
import useRegisterExit from "../../../hooks/useRegisterExit";
import { useTranslation } from "../../../hooks/useTranslation";
import clsx from "clsx";
import { useStore } from "../../../hooks/useStore";

const useStyle = makeStyles({
  root: {
    paddingBottom: 20,
  },
  card: {
    boxShadow:
      " 0px 3px 6px 0px rgb(0 0 0 / 10%), 0px 3px 20px 0px rgb(0 0 0 / 20%)",
  },
  labelContainer: { display: "flex", flexDirection: "row" },
  labelTitle: { color: "#3F414E", paddingRight: 5 },
  labelValue: { color: "rgba(0, 0, 0, 0.87)", fontWeight: 600 },
  spacingBottom: { paddingBottom: 100 },
});

type LabelProp = {
  title: string,
  value: string,
};

const RegisterExitDataMobile = () => {
  const { BundleKey, t } = useTranslation();
  const { openRegister } = useRegisterExit();
  const { isMobile } = useBreakpoint();
  const classes = useStyle();
  const { registerExitStore } = useStore();

  const Label = ({ title, value }: LabelProp) => (
    <div className={classes.labelContainer}>
      <Typography variant="body2" component="p" className={classes.labelTitle}>
        {`${title}:`}
      </Typography>
      <Typography variant="body2" component="p" className={classes.labelValue}>
        {value}
      </Typography>
    </div>
  );

  const onSelect = (userSelected: any) => {
    openRegister(userSelected);
  };

  return (
    <Grid
      id="scrollableItem"
      container
      spacing={2}
      className={clsx(classes.root, {
        [classes.spacingBottom]: isMobile,
      })}
    >
      {registerExitStore.listPeopleInside.length === 0 ? (
        <Grid item xs={12}>
          <h3>{t(BundleKey.REGISTEREXIT_NOTFOUND)}</h3>
        </Grid>
      ) : (
        registerExitStore.listPeopleInside.map((item) => (
          <Grid
            key={item.id}
            item
            xs={12}
            sm={registerExitStore.listPeopleInside.length === 1 ? 12 : 6}
          >
            <Card className={classes.card}>
              <CardActionArea onClick={() => onSelect(item)}>
                <CardContent>
                  <Label
                    title={t(BundleKey.REGISTEREXIT_GRID_HEAD_LOT)}
                    value={
                      item.event?.lotNumbers
                        ? item.event.lotNumbers.toString().replaceAll(",", "\n")
                        : ""
                    }
                  />
                  <Label
                    title={t(BundleKey.REGISTEREXIT_GRID_HEAD_NANE)}
                    value={`${item.firstname} ${item.lastname}`}
                  />
                  <Label
                    title={t(BundleKey.REGISTEREXIT_GRID_HEAD_DNI)}
                    value={item.dni}
                  />
                  <Label
                    title={t(BundleKey.REGISTEREXIT_GRID_HEAD_PLATE)}
                    value={item.event.vehicle ? item.event.vehicle.plate : ""}
                  />
                  <Label
                    title={t(BundleKey.REGISTEREXIT_GRID_HEAD_DATE)}
                    value={
                      moment(item.event.datetime).format("DD-MMM HH:mm") + " hs"
                    }
                  />
                  <Label
                    title={t(BundleKey.REGISTEREXIT_GRID_HEAD_OBSERVATIONS)}
                    value={item.event.comment || item.event.comments || "-"}
                  />
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))
      )}
    </Grid>
  );
};

export default RegisterExitDataMobile;
